import { tokenUtility } from '@fluentsms/auth';
import { gql, useQuery, User } from '@fluentsms/graphql';
import resolveEnv, { PROD, resolveDomain, TITLESOLUTIONS } from '@fluentsms/utils';
import jwtDecode from 'jwt-decode';

const GET_USER_DATA = gql`
  query GetUserForProfile($id: String!) {
    getUser(id: $id) {
      id
      firstName
      middleName
      lastName
      displayName
      initials
      nameSuffix
      jobTitle
      phoneNumbers {
        type
        phoneNumber
        ext
        isPrimary
      }
      emailAddress
      updatedTimestamp
      loginInfo {
        lastLoginDate
        userStatus
      }
      altaId
      nmlsId
    }
  }
`;

export function useProductFruits() {
  const token: string | null = tokenUtility.getIdToken();

  const decodedToken: Record<string, { userId: string }> = token ? jwtDecode(token) : {};
  const env: string = resolveEnv() === PROD ? '' : `${resolveEnv().toLowerCase()}.`;
  const domain: string =
    resolveDomain() === TITLESOLUTIONS ? `fluentapi.${resolveDomain()}.com` : `api.${resolveDomain()}.com`;
  const userId: string = token ? decodedToken[`https://${env}${domain}/users/auth`]?.userId ?? '' : '';
  const { data, loading } = useQuery<{ getUser: User }>(GET_USER_DATA, {
    variables: { id: userId },
    skip: !token,
  });

  if (token) {
    const user = {
      email: data?.getUser.emailAddress ?? '',
      firstname: data?.getUser.firstName ?? '',
      lastname: data?.getUser.lastName ?? '',
      signUpAt: '',
      username: data?.getUser.emailAddress ?? '',
      props: {
        altaId: data?.getUser.altaId ?? '',
        displayName: data?.getUser.displayName ?? '',
        id: data?.getUser.id ?? '',
        loginInfo: {
          lastLoginDate: data?.getUser.loginInfo?.lastLoginDate ?? '',
          userStatus: data?.getUser.loginInfo?.userStatus ?? '',
        },
        nmlsId: data?.getUser.nmlsId ?? '',
      },
    };

    return {
      loading,
      user,
    };
  }

  return {
    loading: false,
    user: null,
  };
}
